import Linkify from "linkify-react";
import moment from "moment";
import React from "react";
import Typography from "../../../Typography";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

const CampaignCard = ({ data, storeName, currencyView }) => {
  return (
    <div
      className="final-camp-card"
      style={{
        backgroundColor: data?.colors?.theme || "#1F746A",
        color: data?.colors?.text || "#ffffff",
      }}
    >
      <div className="card-header">
        <TransformWrapper
          disabled={true}
          initialScale={data?.banner_position?.scale || 1}
          initialPositionX={data?.banner_position?.position_x || 0}
          initialPositionY={data?.banner_position?.position_y || 0}
        >
          <TransformComponent>
            <img
              alt="banner_image"
              title="banner image"
              className="banner_image"
              src={data?.banner}
            />
          </TransformComponent>
        </TransformWrapper>
      </div>
      <div
        className="card-logo-div"
        style={{
          backgroundColor: data?.colors?.text || "#fff",
        }}
      >
        {data?.logo ? (
          <img
            src={data?.logo}
            width="100px"
            alt="card-logo"
            title="Brand Logo"
            className="card-logo-image"
          />
        ) : (
          <p
            style={{ color: data?.colors?.theme || "#1F746A" }}
            className="card-logo-name"
          >
            {storeName || "Reelo"}
          </p>
        )}
      </div>
      <div className="card-content">
        <h3
          className="camptitle"
          style={{
            color: data?.colors?.text || "#fff",
          }}
        >
          {data?.title}
        </h3>
        {data?.reward?.settings?.min_bill?.is_active && (
          <Typography
            size="text-sm"
            weight="medium"
            style={{
              marginTop: "12px",
              textAlign: "center",
              color: data?.colors?.text || "#fff",
            }}
          >
            On min purchase of {currencyView}
            {data?.reward?.settings?.min_bill?.value}
          </Typography>
        )}
        <Linkify
          options={{
            target: "_blank",
          }}
        >
          <p
            className="desc"
            style={{
              color: data?.colors?.text || "#fff",
            }}
          >
            {data?.subtitle}
          </p>
        </Linkify>
        <hr
          style={{
            background: data?.colors?.text || "#fff",
          }}
        />
        <h5>
          Expires on{" "}
          {moment(data?.expires_at).format("DD MMM YYYY") || "10 June 2021"}
        </h5>
        <p
          className="desc"
          style={{
            color: data?.colors?.text || "#fff",
          }}
        >
          {data?.terms}
        </p>
      </div>
      <div className="preview-footer">
        <h5>How to redeem ?</h5>
        <p
          className="desc"
          style={{
            color: data?.colors?.text || "#fff",
          }}
        >
          1. Visit the store & show this coupon
        </p>
        <p
          className="desc"
          style={{
            color: data?.colors?.text || "#fff",
          }}
        >
          2. Give mobile no. and redeem via OTP
        </p>
      </div>
      <p className="foot">
        The campaign can be redeemable{" "}
        {data?.redemption_per_customer === "single" ? "once" : "multiple times"}
        .
      </p>
      {data?.hide_contact_number ? (
        <></>
      ) : (
        <p className="foot">
          Call{" "}
          <a href={`tel:${data?.contact_number}`}>
            <u>{data?.contact_number}</u>
          </a>{" "}
          for more details{" "}
        </p>
      )}
    </div>
  );
};

export default CampaignCard;
